import { render, staticRenderFns } from "./IntegrationMonitoringTable.vue?vue&type=template&id=52244594&"
import script from "./IntegrationMonitoringTable.vue?vue&type=script&lang=js&"
export * from "./IntegrationMonitoringTable.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationMonitoringTable.vue?vue&type=style&index=0&id=52244594&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports